$(document).ready(function () {

    $(document).on("click", ".confirmLink", function (e) {
        e.preventDefault();
        let link = $(this);
        let ask = "Opravdu chcete odebrat tento záznam?";

        if(isDefined(link.data("ask"))){
            ask = link.data("ask");
        }

        let confirmDialog = new ConfirmDialog(ask, {
            event: e
        });

        confirmDialog.create(function (result) {
            if(result){
                let url = link.data("href");
                let ajax = link.data("ajax");

                if(ajax === "on"){
                    $.nette.ajax({
                        url: url,
                        success: function (payload) {

                        }
                    });
                } else {
                    window.location.href = url;
                }
            }
        });

    });

});

$(document).ready(function() {
    // Handler for the reject button
    $(document).on("click", ".rejectLink", function(e) {
        console.log("Reject button clicked");
        e.preventDefault();
        const userId = $(this).data("id");
        console.log("User ID:", userId);

        // Store the user ID in the modal for later use
        $("#rejectModal").data("userId", userId);

        // Show the modal
        $("#rejectModal").modal("show");
    });

    $(document).on("click", "#confirmReject", function() {
        const userId = $("#rejectModal").data("userId");
        const rejectUrl = $(".rejectLink[data-id='" + userId + "']").data("rejectUrl");
        const reason = $("#rejectReason").val().trim();

        if (!reason) {
            toastr.error("Prosím zadejte důvod zamítnutí.");
            return;
        }

        $.nette.ajax({
            url: rejectUrl,
            type: "POST",
            data: {
                reason: reason
            },
            success: function(payload) {
                $("#rejectModal").modal("hide");
            }
        });
    });
});

$(document).ready(function () {

    if(isDefined($.fn.select2)) {
        $(".select2").select2();
    }

    $('.custom-file-input').on('change',function() {
        let fileName = this.files[0].name;
        $(this).siblings('.custom-file-label').first().addClass("selected").html(fileName);
    });

});

$(document).ready(function() {
    if (typeof $.nette !== 'undefined') {
        $.nette.ext('maintenance', {
            complete: function (xhr) {
                try {
                    const contentType = xhr.getResponseHeader('content-type') || '';
                    if (contentType.includes('application/json')) {
                        const response = JSON.parse(xhr.responseText);
                        if (response.maintenance === true) {
                            window.location.href = response.redirect;
                            return false;
                        }
                    }
                } catch (e) {
                    // Not JSON or parsing failed, continue normally
                }
            }
        });
    }
});



